import { jsx as _jsx } from "react/jsx-runtime";
import { getOrderRelatedItemById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { getGroupedLines } from '../../../utils/get-grouped-lines';
const b = bemClassBuilder('v-order-item-modifiers');
export const OrderItemModifiers = observer(props => {
    const i18n = useI18n();
    const { modifiers, modifierDetailsTemplate } = props;
    const modifierItems = getModifierItems(modifiers);
    const groupedModifierLines = getGroupedLines(modifierItems, 'id');
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: groupedModifierLines.map(({ key, line, quantity }) => (_jsx("li", Object.assign({ className: b.element('modifier') }, { children: _jsx("span", { children: getFormattedModifierDetails(modifierDetailsTemplate, line.name, quantity, i18n) }) }), key))) })));
});
OrderItemModifiers.displayName = 'OrderItemModifiers';
const getModifierItems = (modifiers) => modifiers.map(modifier => {
    const { itemId } = modifier;
    const item = getOrderRelatedItemById(itemId);
    if (!item)
        throw new Error(`Cannot render OrderItem. Item with ID ${itemId} does not exist.`);
    return item;
});
const getFormattedModifierDetails = (template, name, quantity, i18n) => {
    return i18n.template(template, {
        quantity,
        description: i18n.translatable(name)
    });
};
